import { getRequest, postRequest, putRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/quotation`;

const createQuotationDraft = (id: string, payload?: Record<string, string>) => {
  const url = `${baseURL}/create-draft/${id}`;
  return postRequest(url, payload ?? {});
};

const getQuotationFormConfig = (id: string) => {
  const url = `${baseURL}/${id}/config`;
  return getRequest(url);
};

const getQuotationDraft = (id: string) => {
  const url = `${baseURL}/draft/${id}`;
  return getRequest(url);
};

const saveQuotationDraft = (id: string, payload: Record<string, string>) => {
  const url = `${baseURL}/draft/${id}`;
  return putRequest(url, payload);
};

const createQuotation = (id: string) => {
  const url = `${baseURL}/draft/${id}/create`;
  return postRequest(url, {});
};

export { createQuotationDraft, getQuotationFormConfig, getQuotationDraft, saveQuotationDraft, createQuotation };
